<form [formGroup]="form" class="ndis-plan-step">
  <ng-container *ngIf="hasNdis; else noNdisBranch">
    <div class="field-group" [class.surface-sunken]="isNdisNumberPrefilled">
      <app-text-input
        [control]="form.controls.ndisNumber"
        [label]="ndisNumberLabel"
        [describedBy]="
          isNdisNumberPrefilled ? ndisNumberControlId + '-prefilled' : null
        "
      />
      <app-prefilled-field-badge
        *ngIf="isNdisNumberPrefilled"
        [id]="ndisNumberControlId + '-prefilled'"
      />
    </div>

    <app-tile-group
      [control]="form.controls.planManagement"
      [options]="planManagementOptions"
      [label]="planManagementLabel"
    />

    <div class="panel" *ngIf="showPlanManagerPanel">
      <p class="panel-title">
        {{ 'SERVICE_PLAN.STEP.NDIS_PLAN.PLAN_MANAGER_PANEL_TITLE' | translate }}
      </p>
      <div class="grid-2">
        <app-text-input
          [control]="form.controls.planManagerName"
          [label]="
            'SERVICE_PLAN.STEP.NDIS_PLAN.PLAN_MANAGER_NAME_LABEL' | translate
          "
        />
        <app-text-input
          [control]="form.controls.planManagerAddress"
          [label]="
            'SERVICE_PLAN.STEP.NDIS_PLAN.PLAN_MANAGER_ADDRESS_LABEL' | translate
          "
        />
        <app-text-input
          [control]="form.controls.planManagerContactName"
          [label]="
            'SERVICE_PLAN.STEP.NDIS_PLAN.PLAN_MANAGER_CONTACT_NAME_LABEL'
              | translate
          "
        />
        <app-text-input
          [control]="form.controls.planManagerContactEmailPhone"
          [label]="
            'SERVICE_PLAN.STEP.NDIS_PLAN.PLAN_MANAGER_CONTACT_EMAIL_PHONE_LABEL'
              | translate
          "
        />
      </div>
    </div>
  </ng-container>

  <ng-template #noNdisBranch>
    <app-pill-choice
      [control]="form.controls.applyingForNdis"
      [label]="applyingForNdisLabel"
    />
    <app-pill-choice [control]="form.controls.hasPhi" [label]="hasPhiLabel" />

    <ng-container *ngIf="showPhiDetails">
      <app-dropdown
        [control]="form.controls.phiCountry"
        [data]="phiCountryOptions"
        [label]="phiCountryLabel"
      />
      <app-text-input
        [control]="form.controls.phiInsurerName"
        [label]="
          'SERVICE_PLAN.STEP.NDIS_PLAN.PHI_INSURER_NAME_LABEL' | translate
        "
      />
      <app-text-input
        [control]="form.controls.phiMemberNo"
        [label]="'SERVICE_PLAN.STEP.NDIS_PLAN.PHI_MEMBER_NO_LABEL' | translate"
      />
    </ng-container>
  </ng-template>

  <div class="date-row">
    <app-datepicker
      [control]="form.controls.startDate"
      [label]="startDateLabel"
    />
    <app-datepicker
      [control]="form.controls.endDate"
      [label]="endDateLabel"
      [isReadOnly]="isEndDateReadOnly"
    />
  </div>
</form>
